import API from 'app/gamma/src/api';
import React from 'react';
import { MemberResponse } from 'app/gamma/src/types/responses';
import styles from './MoonshotInviteTeamMembers.less';
import { Spinner } from 'app/src/components/Spinner';
import { useFeatureFlag } from '@trello/feature-flag-client';

const MemberMultiSelectAutocompleteComponent = require('app/scripts/views/member/member-multi-select-autocomplete-component');

const onMemberSearchFetch = (
  query: string,
  idOrganization = '',
): Promise<MemberResponse[]> => {
  if (query.length > 2) {
    return API.client.searchMembers({
      query: query,
      idOrganization,
    });
  } else {
    return Promise.resolve([]);
  }
};

interface MoonshotInviteTeamMembersProps {
  orgId: string;
  setInvitationMessage: (message: string) => void;
  invitationMessage: string;
  isInvitingMembers: boolean;
  updateMembers: (action: object) => void;
  selectedMembers: MemberResponse[];
  orgName: string;
  // This allows the ability to override the search query
  // for things like tests and storybook
  onMemberSearch?: typeof onMemberSearchFetch;
}

export const MoonshotInviteTeamMembers: React.FC<MoonshotInviteTeamMembersProps> = ({
  orgId,
  orgName,
  onMemberSearch = onMemberSearchFetch,
  setInvitationMessage,
  invitationMessage,
  isInvitingMembers,
  updateMembers,
  selectedMembers,
}) => {
  const messageEnabledFlag = useFeatureFlag(
    'enable-invite-email-message',
    false,
  );

  if (messageEnabledFlag) {
    setInvitationMessage(
      `Hi, I’d like to invite you to join ${orgName} on Trello. We use Trello to organize tasks, projects, due dates and much more.`,
    );
  }

  return (
    <div className={styles.inviteTeamMembers}>
      <h2>
        Loop in your Team Members<em>You can do this later, too!</em>
      </h2>
      <MemberMultiSelectAutocompleteComponent
        submitAlwaysEnabled
        fullWidthButton
        shouldFocusOnSelectMemberOption
        displayDetails
        displayUsername
        hideDefaultButton
        placeholder="Type another email address..."
        emptySearchText="Looks like that person isn't a Trello member yet. Add their email address to invite them."
        submitText={
          isInvitingMembers ? <Spinner centered /> : 'Next, Select a Plan'
        }
        onAutocompleteSearch={(query: string) => onMemberSearch(query, orgId)}
        onSelectMemberOption={(members: MemberResponse | MemberResponse[]) => {
          if (members instanceof Array) {
            members.map((member) => updateMembers({ type: 'add', member }));
          } else {
            updateMembers({ type: 'add', member: members });
          }
        }}
        onRemoveMemberOption={(removedIndex: number) => {
          updateMembers({ type: 'remove', memberIndex: removedIndex });
        }}
        selectedOptions={selectedMembers}
      >
        <p className={styles.small}>
          <strong>Tip!</strong> You can paste as many emails here as needed.
        </p>
        {messageEnabledFlag && (
          <>
            <h3>Include a personal message</h3>
            <textarea
              value={invitationMessage}
              onChange={(event) => {
                setInvitationMessage(event.target.value);
              }}
              maxLength={500}
            />
          </>
        )}
        <div className={styles.buttonSpacer} />
      </MemberMultiSelectAutocompleteComponent>
    </div>
  );
};
